
// <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M10.45 6.71997L6.72998 3L3.01001 6.71997" stroke={upColor} stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// <path d="M6.72998 21V3" stroke={upColor} stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>

// <path d="M13.55 17.28L17.27 21L20.99 17.28" stroke={downColor} stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// <path d="M17.27 3V21" stroke={downColor} stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </svg> -->

import React from 'react';

const ClasicArrowDown = ({ color = '#06060690', size = 24, onClick }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick} // Obsługa kliknięcia
    >
      {/* Dolna strzałka */}
      <path
        d="M1.55 17.28L5.27 21L8.99 17.28"
        stroke={color}
        strokeOpacity="0.6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.27 3V21"
        stroke={color}
        strokeOpacity="0.6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ClasicArrowDown;
